<template>
    <div class="stepper">
      <p v-if="isSmallScreen">
        STEP <span>{{ step }}</span> of 6
      </p>
      <ul v-else>
        <li v-for="n in 6" :key="`step-${n}`">
          <span class="number" :class="{ active: step === n, done: step > n }">{{ n }}</span>  
          <span class="name" :class="{ active: step === n }" v-if="(n == 5)">{{ (n == 5 && $store.state.guestLogin.cartTotal == 0 && $store.state.guestLogin.cartTotal != null) ? 'Contact information' : STEPS[n].name }}</span>  
          <span class="name" :class="{ active: step === n }" v-else>{{ STEPS[n].name }}</span>  
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex'
  
  export default {
    name: "Stepper",
    props: {
      step: {
        type: Number,
        required: true
      },
    },
    data() {
      return {
        isSmallScreen: false,
      };
    },
    computed: {
      ...mapState([
        'STEPS',
      ]),

      subTotal() {
        let total = 0;
        this.$store.state.guestLogin.renewalCart && this.$store.state.guestLogin.renewalCart.forEach(function (obj)  {
            obj.onlineTransactionFeeCollection.forEach(function (txn){
                total = total + txn.feeAmount;
            })   
        });
        return total;
      },
    },
    created() {
      window.addEventListener('resize', this.onResize);
    },
    destroyed () {
      window.removeEventListener('resize', this.onResize);
    },
    mounted() {
      this.onResize();
    },
    methods: {
      onResize () {
        this.isSmallScreen = (window.innerWidth <= 610);
      },
    }
  }
  </script>
  
  <style scoped lang="scss">
  .stepper {
    background-color: var(--ri-light-gray);
    @extend %global-side-padding;
    p {
      @extend %font-serif-regular;  // media query cannot do @extend
      font-size: 1.15rem;
      font-weight: 700;
      padding: 0.5em 0;
      span {
        color: var(--ri-orange);
      }
    }
    ul {
      @extend %flex-row-space-between;
      padding: 1.25em 0;
      li {
        @extend %flex-row-space-between;
        font-size: 0.875rem;
        text-align: center;
        align-self: flex-start;
        .number {
          background-color: var(--ri-light-blue);
          border-radius: 16px;
          @extend %font-sans-bold;
          font-size: 1rem;
          padding: 0.4em 0.7em;
          height: 32px;
          width: 32px;
          &.active {
            background-color: orange;
          }
          &.done {
            background-color: var(--ri-gray);
          }
        }
        .name {
          margin-left: 0.75em;
          margin-right: 0.75em;
          &.active {
            @extend %font-sans-bold;
          }
        }
      }
    }
    @media print {
      display: none;
    }
  }
  @media only screen and (max-width: 1200px) {
    .stepper {
      li {
        flex-direction: column;
        .name {
          margin-top: 0.5em;
        }
      }
    }
  }
  </style>
  